export default "__VITE_ASSET__CcfQLjDb__"